import { ComponentType } from '@angular/cdk/overlay'
import { Injectable, TemplateRef } from '@angular/core'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'

@Injectable({
    providedIn: 'root'
})
export class DialogService {
    constructor(readonly dialog: MatDialog) {}
    open<T>(
        component: ComponentType<T> | TemplateRef<T>,
        hasData?: object,
        panelClass = '',
        disableClose = true
    ): MatDialogRef<T> {
        return this.dialog.open(component, {
            width: '95vw',
            maxWidth: '95vw',
            maxHeight: '95%',
            panelClass,
            data: hasData,
            disableClose
        })
    }
}
